import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Theme/hijunior/components/Button/Button';
import Container from '@Theme/hijunior/components/Container/Container';
import Row from '@Theme/hijunior/components/Row/Row';
import Column from '@Theme/hijunior/components/Column/Column';
import Icon from '@Theme/hijunior/components/Icon/Icon';
import Text from '@Theme/hijunior/components/Text/Text';
import Picture from '@Theme/hijunior/components/Picture/Picture';

import * as styles from './Content.module.scss';

const propTypes = {
  /**
   * Heading to display in module
   */
  heading: PropTypes.string,

  /**
   * Description to display in module
   */
  description: PropTypes.string,

  /**
   * List of elements to display in module
   */
  list: PropTypes.arrayOf(
    PropTypes.string
  ),

  /**
   * Button content and settings
   */
  button: PropTypes.shape({
    content: PropTypes.string,
    url: PropTypes.string
  }),

  /**
   * Picture url as string localize path
   */
  picture: PropTypes.shape({
    xs: PropTypes.shape({
      src: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number
    }),
    alt: PropTypes.string
  }),

  /**
   * Picture position if set to true picture on the right
   */
  hasPictureOnTheLeft: PropTypes.bool,

  /**
   * Additional classname
   */
  classname: PropTypes.string
};

const Content = ({
  heading,
  description,
  list,
  button,
  picture,
  hasPictureOnTheLeft,
  classname
}) => {
  return (
    <section className={`${styles.root} ${classname || ''}`}>
      <Container>
        <Row
          classname={`${styles.rootRow}`}
          reversed={hasPictureOnTheLeft}
          valign={'middle'}>
          <Column
            classname={styles.rootCol}
            xs={4}
            md={{
              col: 6
            }}
            lg={hasPictureOnTheLeft ? {
              col: 5,
              offset: 1
            } : 6}>
            <Text as='h2' classname={styles.rootHeading} contents={heading} />
            <Text classname={styles.rootDescription} contents={description} />

            {list && (
              <ul className={styles.rootList}>
                {list?.map((item, index) => (
                  <li
                    className={`${styles.rootListItem}`}
                    key={index}>
                    <Icon classname={styles.rootListItemIcon} name='listIcon' />
                    <Text
                      as={'p'}
                      contents={item}
                      classname={styles.rootListItemText}/>
                  </li>
                )
                )}
              </ul>)
            }
            {button  &&  <Button
              content={button.content ? button.content : false}
              url={button.url ? button.url : false}
              classname={styles.rootButton}
              size='medium'/>}
          </Column>
          <Column
            classname={styles.rootCol}
            xs={4}
            md={hasPictureOnTheLeft ? 6 : {
              col: 6,
              offset: 0
            }}
            lg={hasPictureOnTheLeft ? 6 : {
              col:5,
              offset:1
            }}>
            {picture && <Picture
              pictureClassname={`${styles.rootPicture} ${
                hasPictureOnTheLeft ? styles.rootPictureReversed : ''
              }`}
              imgClassname={styles.rootImage}
              {...picture} />
            }
          </Column>
        </Row>
      </Container>
    </section>
  );
};

Content.propTypes = propTypes;

export default Content;
